__turbopack_context__.v({
  "notifications-dialog": "xpJcuW_notifications-dialog",
  "notifications-dialog__content": "xpJcuW_notifications-dialog__content",
  "notifications-dialog__header": "xpJcuW_notifications-dialog__header",
  "notifications-modal-container": "xpJcuW_notifications-modal-container",
});
